<template>
  <div>
    <div style="margin-bottom:15px;">
      <span class="common-title">审批记录</span>
      <span class="text-color-blue pointer right-oper" @click="showMore = !showMore">
        {{ showMore ? "收起" : "展开" }}
        <a-icon :type="showMore ? 'up' : 'down'" style="font-size:12px" />
      </span>
    </div>
    <a-table v-if="showMore && pageData.length > 0" size="middle" :columns="columns" :row-key="(record, index) => record.id+'_'+index"
             :data-source="pageData" bordered :scroll="{}" :locale="{emptyText:'暂无数据'}">
      <template slot="approveTime" slot-scope="text">
        {{
          text | dateFormat("YYYY-mm-dd HH:MM:SS")
        }}
      </template>

    </a-table>
    <table v-if="!showMore || pageData.length == 0" class="table-common">
      <thead>
        <tr>
          <th>业务节点</th>
          <th>提交/审批人</th>
          <th>提交/审批结果</th>
          <th>审批意见</th>
          <th>操作时间</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!showMore">
          <td colspan="8" style="text-align: center;color:#999;font-size:18px;">
            ···
          </td>
        </tr>
        <tr v-if="showMore && pageData.length == 0">
          <td colspan="8" style="text-align: center;">暂无数据</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { getGoldenTicketApproveList, getBizGldRepayApproveRecordList, getBizGldPayApproveRecordList } from '@/api/gold.js';
export default {
  name: 'gold-detail-approve-history',
  data() {
    return {
      pageData: [],
      showMore: false,
      columns: [
        {
          title: '业务节点',
          dataIndex: 'businessType'
        },
        {
          title: '提交/审批人',
          dataIndex: 'userName',
          width: 120,
          ellipsis: true
        },
        {
          title: '提交/审批结果',
          dataIndex: 'approveStatus',
          ellipsis: true
        },
        {
          title: '审批意见',
          dataIndex: 'approveRemark',
          ellipsis: true
        },
        {
          title: '操作时间',
          dataIndex: 'approveTime',
          scopedSlots: { customRender: 'approveTime' }
        }
      ]
    };
  },
  created() {
    this.getTableList();
  },
  methods: {
    getTableList() {
      if (this.$route.params.gldId) {
        getGoldenTicketApproveList({
          gldId: this.$route.params.gldId
        })
          .then((res) => {
            this.pageData = res.data || [];

            console.log('%c Line:92 🍅', 'color:#6ec1c2', this.$route.query);
            // 兑付审批记录
            console.log("%c Line:95 🍩 this.$route.query.detailFrom == 'detailFrom'", 'color:#fca650', this.$route.query.detailFrom == 'detailFrom');
            if (this.$route.query.detailFrom == 'payment') {
              getBizGldRepayApproveRecordList({
                gldId: this.$route.params.gldId
              })
                .then((res) => {
                  console.log('%c Line:99 🍞 res', 'color:#ed9ec7', res);
                  if (res.data && res.data.grid && res.data.grid.list && res.data.grid.list.length > 0) {
                    res.data.grid.list.forEach((item) => {
                      this.pageData.push({ ...item, approveTime: item.approveDate ,approveStatus:item.result,approveRemark:item.opinion });
                    });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
            // 支付审批记录
            if (this.$route.query.detailFrom == 'goldpay') {
              getBizGldPayApproveRecordList({
                gldId: this.$route.params.gldId
              })
                .then((res) => {
                  if (res.data && res.data.grid && res.data.grid.list && res.data.grid.list.length > 0) {
                    res.data.grid.list.forEach((item) => {
                      this.pageData.push({ ...item, approveTime: item.approveDate ,approveStatus:item.result,approveRemark:item.opinion });
                    });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  },
  watch: {
    gldId(newVal) {
      this.getTableList();
    }
  },
  activated() {}
};
</script>
<style scoped>
.right-oper {
  float: right;
  margin: 0 10px 10px 0;
}
.table-common {
  width: 100%;
}
.table-common th {
  background: #f5f9fb;
  color: #1b1d1f;
}
.table-common th,
.table-common td {
  padding: 10px 10px;
  text-align: center;
  color: #1b1d1f;
}
.table-common td {
  font-size: 12px;
  background: #ffffff;
  border-bottom: 5px solid #f5f9fb;
}
.table-common tbody tr:nth-child(2n) {
  background: #f5f7f9;
}
</style>



// WEBPACK FOOTER //
// src/components/gold-page/gold-detail-approve-history.vue